module.exports = __webpack_public_path__ + "static/media/ac-light-gray.408cfe71.svg";